import { render } from "./WordListItem.vue?vue&type=template&id=c0b0ad18&ts=true"
import script from "./WordListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./WordListItem.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/word/components/WordListItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c0b0ad18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c0b0ad18', __exports__)) {
    api.reload('c0b0ad18', __exports__)
  }
  
  module.hot.accept("./WordListItem.vue?vue&type=template&id=c0b0ad18&ts=true", () => {
    api.rerender('c0b0ad18', render)
  })

}


export default __exports__